import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  IonIcon,
  IonPopover,
  IonButtons,
  IonButton,
  IonList,
  IonItem,
  IonLabel,
} from "@ionic/react";
import {
  logoFacebook,
  logoLinkedin,
  logoTwitter,
  shareSocial,
} from "ionicons/icons";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import ReactTooltip from "react-tooltip";
import { logEvent } from "firebase/analytics";
import { analytics } from "..";

const SocialSharePopover = ({ projectName }) => {
  let location = useLocation();
  const [popoverState, setShowPopover] = useState({ showPopover: false });
  const logShareFB = () => {
    logEvent(analytics, "share", {
      method: "Facebook",
      content_type: "project_page",
      content_id: projectName,
    });
  };
  const logShareTW = () => {
    logEvent(analytics, "share", {
      method: "Twitter",
      content_type: "project_page",
      content_id: projectName,
    });
  };
  const logShareLI = () => {
    logEvent(analytics, "share", {
      method: "LinkedIn",
      content_type: "project_page",
      content_id: projectName,
    });
  };
  return (
    <>
      <IonPopover
        mode="ios"
        cssClass="social-share-popover"
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => setShowPopover({ showPopover: false })}
      >
        <IonList className="project-list">
          <FacebookShareButton
            onClick={logShareFB}
            url={`https://fy20-wmi-website.web.app${location.pathname}`}
          >
            <IonItem lines="none" id="alert-button" detail={false}>
              <IonIcon
                ios={logoFacebook}
                slot="start"
                size="large"
                className="alert-icon"
                style={{ color: "#4267B2" }}
              />
              <IonLabel>
                <span className="share-label">Facebook</span>
              </IonLabel>
            </IonItem>
          </FacebookShareButton>
          <TwitterShareButton
            onClick={logShareTW}
            url={`https://fy20-wmi-website.web.app${location.pathname}`}
          >
            <IonItem lines="none" button id="alert-button" detail={false}>
              <IonIcon
                ios={logoTwitter}
                slot="start"
                size="large"
                className="alert-icon"
                style={{ color: "#1DA1F2" }}
              />
              <IonLabel>
                <span className="share-label">Twitter</span>
              </IonLabel>
            </IonItem>
          </TwitterShareButton>
          <LinkedinShareButton
            title={projectName}
            source="AMI Projects"
            onClick={logShareLI}
            url={`https://fy20-wmi-website.web.app${location.pathname}`}
          >
            <IonItem lines="none" button id="alert-button" detail={false}>
              <IonIcon
                ios={logoLinkedin}
                slot="start"
                size="large"
                className="alert-icon"
                style={{ color: "#0e76a8" }}
              />
              <IonLabel>
                <span className="share-label">LinkedIn</span>
              </IonLabel>
            </IonItem>
          </LinkedinShareButton>
        </IonList>
      </IonPopover>
      <IonButtons style={{ position: "absolute", top: "15px", right: "15px" }}>
        <IonButton
          onClick={(e) => {
            e.persist();
            setShowPopover({ showPopover: true, event: e });
          }}
          aria-label="Share"
          data-tip="Share Project"
          data-place="left"
          data-effect="solid"
          data-for="share-tooltip"
          data-offset="{'right': 10}"
        >
          <IonIcon
            icon={shareSocial}
            color="primary"
            style={{ fontSize: "23px" }}
          />
        </IonButton>
      </IonButtons>
      <ReactTooltip id="share-tooltip" className="custom-tooltip" />
    </>
  );
};

export default SocialSharePopover;
